import { render } from "./contact-me.vue?vue&type=template&id=7f36e9c1&scoped=true"
import script from "./contact-me.vue?vue&type=script&lang=js"
export * from "./contact-me.vue?vue&type=script&lang=js"

import "./contact-me.vue?vue&type=style&index=0&id=7f36e9c1&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f36e9c1"]])

export default __exports__